export const BET_BUILDER = 'BetBuilder';
// Bet-type id returned by the swarm `check_terminal_bet_ticket` response for
// bet builder tickets. Mirrors BetTypeEnum.InternalBetBuilder in the betslip.
export const BET_BUILDER_TYPE_ID = 51;

export const TicketTypes = {
  DEPOSIT: 'deposit',
  SPORT: 'sport',
  CASINO: 'casino',
  ADMIN: 'admin',
  BET_BUILDER: 'bet_builder',
};

export const TerminalTicketTypeEnum = {
  [TicketTypes.SPORT]: 1,
  [TicketTypes.CASINO]: 2,
}